import React, { useEffect, useRef } from "react";

export default function AboutUs() {
  const sectionRef = useRef(null);

  // Scroll Observer to trigger animations when the section comes into view
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("visible");
          }
        });
      },
      { threshold: 0.2 } // Trigger when 20% of section is visible
    );

    const section = sectionRef.current;
    if (section) {
      const elements = section.querySelectorAll(".animate-on-scroll");
      elements.forEach((el) => observer.observe(el));
    }

    return () => {
      if (section) {
        // Cleanup
        const elements = section.querySelectorAll(".animate-on-scroll");
        elements.forEach((el) => observer.unobserve(el));
      }
    };
  }, []);

  return (
    <section className="about-section" ref={sectionRef}>
      <div className="about-container">
        <div className="about-grid">
          
          {/* --- Left Column: The Story --- */}
          <div className="about-content">
            <div className="about-header animate-on-scroll">
              <span className="about-tag">SINCE 2025</span>
              <h2 className="about-title">
                Our Story, <span className="highlight">Stitched</span> with Love
              </h2>
              {/* Decorative Animated Needle Line */}
              <div className="needle-line-wrapper">
                <div className="needle-line"></div>
                <div className="needle-icon">🪡</div>
              </div>
            </div>

            <div className="about-body">
              <p className="about-para animate-on-scroll delay-1">
                What began as a simple interest in crochet and hand embroidery grew into a passion that shaped Bandham. Through learning, practice, and dedication, we transformed our love for handmade art into meaningful creations.
              </p>

              <p className="about-para animate-on-scroll delay-2">
                Today, we craft custom embroidered pieces—from photo embroidery and hoop frames to crochets and personalized napkins—each made with care and intention. In a world of mass production, we aim to revive the warmth and personal touch of handmade gifts, where every stitch carries emotion, quality, and trust.
              </p>

              {/* <p className="about-para animate-on-scroll delay-3">
                Handmade gifts have become rare in today’s fast-paced world, and we
                wanted to revive that charm—bringing back the warmth, texture, and
                personal connection that machine-made items often lack. Every stitch
                we place carries our commitment to quality, love for the craft, and
                respect for the customer who trusts us with their memories.
              </p> */}
            </div>
            
            {/* Signature / Brand Name */}
            <div className="about-signature animate-on-scroll delay-3">
              - Bandham
            </div>
          </div>

          {/* --- Right Column: The Logo Display --- */}
          <div className="about-visual animate-on-scroll">
            <div className="logo-frame-container">
              {/* Rotating Dashed Circle (Like stitches) */}
              <div className="stitch-ring"></div>
              
              {/* Solid Gold Ring (Like a Hoop) */}
              <div className="hoop-ring"></div>
              
              {/* The Logo Image */}
              <div className="logo-wrapper">
                {/* REPLACE with your actual Logo Path */}
                <img 
                  src="images/logo.webp" 
                  alt="Bandham Official Logo" 
                  className="about-logo" 
                />
              </div>
            </div>
            
            {/* Background decorative blob */}
            <div className="bg-blob"></div>
          </div>

        </div>
      </div>
    </section>
  );
}